import moment from 'moment';
import React, { useState } from 'react';
import { PaymentPlanLogType, } from '@debbie/common/dist/economy/payment-plans';
import { Table, Badge, Modal } from '..';
import THEME from '../../theme';
import { usePaymentPlanLogs } from '@debbie/cortex/dist/paymentPlans';
import { h } from '@debbie/cortex/dist';
import { ExternalLink } from '../Icons';
const Logs = (props) => {
    const paymentPlanLogsLoadable = usePaymentPlanLogs(props.paymentPlanId);
    const paymentPlanLogs = h.hasData(paymentPlanLogsLoadable)
        ? paymentPlanLogsLoadable.data
        : [];
    const [modalOpen, setModalOpen] = useState(false);
    const logs = paymentPlanLogs.filter((log) => log.paymentPlanEntryId === props.paymentPlanEntryId &&
        ![PaymentPlanLogType.DeltaShift].includes(log.type));
    if (logs.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Badge, { onClick: () => setModalOpen(!modalOpen), style: { cursor: 'pointer' }, theme: THEME.COLOR_GREY },
            logs.length,
            " ",
            logs.length === 1 ? 'log' : 'logs',
            " ",
            React.createElement(ExternalLink, null)),
        modalOpen && (React.createElement(Modal, { header: 'Logs', onToggle: () => setModalOpen(!modalOpen) },
            React.createElement(Table, null, logs.map((log) => {
                var _a;
                return (React.createElement("tr", null,
                    React.createElement("td", null, log.type),
                    React.createElement("td", null, moment(log.createdAt).format(THEME.DATE_FORMAT_LONG)),
                    React.createElement("td", null, (_a = log.details) === null || _a === void 0 ? void 0 : _a.message)));
            }))))));
};
export default Logs;
//# sourceMappingURL=PaymentPlanLogs.js.map